export const maskText = (text: string): string => {
  if (!text) return "";
  return `${text.toString()?.charAt(0)}***`;
};

export const maskPhone = (phone: string): string => {
  if (!phone) return "";
  return "*** *****";
};

export const maskEmail = (email: string): string => {
  if (!email) return "";
  const [localPart, domain] = email.split("@");
  const [domainName, tld] = domain.split(".");

  return `${localPart.charAt(0)}**@${domainName.charAt(0)}***.${tld.charAt(
    0
  )}***`;
};

export const maskCurrency = (value: string | number): string => {
  if (!value) return "";
  return "***";
};

export const maskNumber = (value: string | number): string => {
  if (!value) return "";
  return "****";
};

export const shouldMaskData = (state: {
  app: { obfuscateSensitiveData: boolean };
}): boolean => {
  return state.app.obfuscateSensitiveData;
};
